// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PhZJX","top50":"styles_top50__VpfG7"};